import React, { useState, useEffect, forwardRef } from "react"
import { Editor as DraftEditor } from "react-draft-wysiwyg"
import { EditorState, ContentState, convertToRaw } from "draft-js"
import htmlToDraft from "html-to-draftjs"
import draftToHtml from "draftjs-to-html"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

const config = {
  options: ["inline", "blockType", "list", "textAlign", "link", "history"],
  inline: {
    options: ["bold", "italic", "underline"],
  },
  blockType: {
    options: ["Normal", "H3"],
  },
}

export const editorStateToHtml = editorState => {
  const contentState = editorState.getCurrentContent()
  if (!contentState.hasText()) return ""
  return draftToHtml(convertToRaw(contentState))
}

const createEditorState = html => {
  if (!html) return EditorState.createEmpty()

  const contentBlock = htmlToDraft(html)
  if (contentBlock) {
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
    return EditorState.createWithContent(contentState)
  }
  return EditorState.createEmpty()
}

const Editor = forwardRef(
  ({ initialContentState = "", onChange, wrapperClassName = "", editorClassName = "", ...props }, ref) => {
    const [editorState, setEditorState] = useState(() => createEditorState(initialContentState))
    const [isInitialized, setIsInitialized] = useState(false)
    const [startTyping, setStartTyping] = useState(false)

    useEffect(() => {
      if (!isInitialized && initialContentState && !startTyping) {
        setEditorState(createEditorState(initialContentState))
        setIsInitialized(true)
      }
    }, [initialContentState, isInitialized, startTyping])

    const handleEditorStateChange = newEditorState => {
      if (!startTyping) {
        setStartTyping(true)
      }
      setEditorState(newEditorState)
      onChange?.(newEditorState)
    }

    return (
      <DraftEditor
        ref={ref}
        editorState={editorState}
        onEditorStateChange={handleEditorStateChange}
        toolbar={config}
        wrapperClassName={`dashboard_text-editor-wrapper ${wrapperClassName}`.trim()}
        editorClassName={`dashboard_text-editor-text ${editorClassName}`.trim()}
        {...props}
      />
    )
  }
)

Editor.displayName = "Editor"

export default Editor
